import { createSelector } from "reselect";

// Intended audience per product decision: ops and super staff, not the
// broader "admin" role set (UserManagement's validateRoles appends
// "admin" to every role that isn't read_only_admin, so that check would
// have matched csr too). This is a UI affordance only - PostAccountFlagInfo
// enforces the real write gate server-side, and as of this change it
// requires the JWT's admin claim (user.IsAdmin), not a Roles check, so the
// two need to be reconciled server-side for ops/super staff to actually be
// able to save a reason rather than hit PermissionDenied.
export const canEditReason = (adminUser) =>
    Boolean(adminUser?.roles?.includes("ops") || adminUser?.roles?.includes("super"));

const flagsDomain = () => (state) => state.accountFlags;
const accountFlagsDomain = () => (state) => state.accountFlags.accounts;
const adminUser = () => (state) => state.user;
const selectedAccountIDDomain = () => (state) =>
    state.selectedMember.get("accountID");
const selectedUserAccountFlags = () =>
    createSelector(
        accountFlagsDomain(),
        selectedAccountIDDomain(),
        (accounts, selectedAccountID) => {
            return accounts[selectedAccountID] || [];
        }
    );

const selectedUserAccountFlagsChanged = () =>
    createSelector(
        accountFlagsDomain(),
        selectedAccountIDDomain(),
        (accounts, selectedAccountID) => {
            return Boolean(
                accounts[selectedAccountID] &&
                    accounts[selectedAccountID].find((f) => f.action)
            );
        }
    );

const selectAccountFlagsContainer = () =>
    createSelector(
        flagsDomain(),
        adminUser(),
        selectedAccountIDDomain(),
        selectedUserAccountFlags(),
        selectedUserAccountFlagsChanged(),
        (
            subState,
            adminUser,
            selectedAccountID,
            selectedAccountFlags,
            userAccountFlagsChanged
        ) =>
            Object.assign({}, subState, {
                adminUser,
                selectedAccountID,
                selectedAccountFlags,
                userAccountFlagsChanged,
            })
    );

export default selectAccountFlagsContainer;
